import k from "./index47.js";
import u from "./index46.js";
import c, { normalizeOpts as d } from "./index30.js";
import m from "./index54.js";
import "./index48.js";
import "./index55.js";
import "./index58.js";
class _ extends m {
  get repeatFrom() {
    var t;
    return (t = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === 1 / 0 ? 0 : this.repeat) != null ? t : 0;
  }
  get repeatTo() {
    var t;
    return (t = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? t : 1 / 0;
  }
  constructor(t) {
    super(t);
  }
  updateOptions(t) {
    super.updateOptions(t);
  }
  _update(t) {
    var i, s, r;
    const {
      repeat: n,
      ...l
    } = d(t);
    this._blockOpts = Object.assign({}, this._blockOpts, l);
    const e = c(this._blockOpts);
    this.repeat = (i = (s = n ?? e.repeat) != null ? s : this.repeat) != null ? i : 1 / 0, super._update({
      mask: "m".repeat(Math.max(this.repeatTo === 1 / 0 && ((r = this._blocks) == null ? void 0 : r.length) || 0, this.repeatFrom)),
      blocks: {
        m: e
      },
      eager: e.eager,
      overwrite: e.overwrite,
      skipInvalid: e.skipInvalid,
      lazy: e.lazy,
      placeholderChar: e.placeholderChar,
      displayChar: e.displayChar
    });
  }
  _allocateBlock(t) {
    if (t < this._blocks.length)
      return this._blocks[t];
    if (this.repeatTo === 1 / 0 || this._blocks.length < this.repeatTo)
      return this._blocks.push(c(this._blockOpts)), this.mask += "m", this._blocks[this._blocks.length - 1];
  }
  _appendCharRaw(t, i) {
    i === void 0 && (i = {});
    const s = new k();
    for (
      let a = (r = (n = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : n.index) != null ? r : Math.max(this._blocks.length - 1, 0), h, o;
      // try to get a block or
      // try to allocate a new block if not allocated already
      h = (l = this._blocks[a]) != null ? l : o = !o && this._allocateBlock(a);
      ++a
    ) {
      var r, n, l, e;
      const p = h._appendChar(t, {
        ...i,
        _beforeTailState: (e = i._beforeTailState) == null || (e = e._blocks) == null ? void 0 : e[a]
      });
      if (p.skip && o) {
        this._blocks.pop(), this.mask = this.mask.slice(1);
        break;
      }
      if (s.aggregate(p), p.consumed)
        break;
    }
    return s;
  }
  _trimEmptyTail(t, i) {
    var s, r;
    t === void 0 && (t = 0);
    const n = Math.max(((s = this._mapPosToBlock(t)) == null ? void 0 : s.index) || 0, this.repeatFrom, 0);
    let l;
    i != null && (l = (r = this._mapPosToBlock(i)) == null ? void 0 : r.index), l == null && (l = this._blocks.length - 1);
    let e = 0;
    for (let a = l; n <= a && !this._blocks[a].unmaskedValue; --a, ++e)
      ;
    e && (this._blocks.splice(l - e + 1, e), this.mask = this.mask.slice(e));
  }
  reset() {
    super.reset(), this._trimEmptyTail();
  }
  remove(t, i) {
    t === void 0 && (t = 0), i === void 0 && (i = this.displayValue.length);
    const s = super.remove(t, i);
    return this._trimEmptyTail(t, i), s;
  }
  totalInputPositions(t, i) {
    return t === void 0 && (t = 0), i == null && this.repeatTo === 1 / 0 ? 1 / 0 : super.totalInputPositions(t, i);
  }
  get state() {
    return super.state;
  }
  set state(t) {
    this._blocks.length = t._blocks.length, this.mask = this.mask.slice(0, this._blocks.length), super.state = t;
  }
}
u.RepeatBlock = _;
export {
  _ as default
};
